import React from 'react'

function ListingInspection() {
  return (
    <section className="ttm-row grid-section clearfix">
    <div className="container">
      {/* row */}
      <div className="row">
        <div className="col-lg-12">
          {/* section title */}
          <div className="section-title title-style-center_text">
            <div className="title-header">
              <h3>OUR SERVICES</h3>
              <h2 className="title">Helping Your Business <b>Grow and Succeed</b></h2>
            </div>
          </div>{/* section title end */}
        </div>
      </div>
      {/* row */}
      <div className="row">
        <div className="col-lg-4 col-md-6 col-sm-6">
          {/*featured-imagebox*/}
          <div className="featured-imagebox featured-imagebox-services style1">
            {/* featured-thumbnail */}
            <div className="featured-thumbnail">
              <img className="img-fluid" src="images/services/services-01-768x512.jpg" alt="image" />
            </div>{/* featured-thumbnail end*/}
            <div className="featured-content">
              <div className="featured-title">
                <h3><a href="fabric-printing.html">Inspection of Fabrics</a></h3>
                <div className="ttm-details-link">
                  <a href="fabric-printing.html"><i className="themifyicon ti-arrow-top-right" /></a>
                </div>
              </div>
              <div className="featured-desc">
                <p>Nask International specializes in textiles and fabrics of all types, including woven and knitted fabrics. We conduct comprehensive fabric inspections based on your provided checklists and standards. Our wide range of quality inspection and testing services includes, but is not limited to, the following textiles and fabrics:
                  ⊕ Textile Fabrics &amp; Canvas
                  ⊕ Home Textiles
                  ⊕ Kitchen Textiles
                  ⊕ Cotton Bags
                  ⊕ Textile Made-ups
                  ⊕ Workwear &amp; Uniforms
                  ⊕ Apparel &amp; Garments
                  ⊕ Cotton Fabric – Plain Weave
                  ⊕ Cotton Canvas Rolls
                  ⊕ Percale, Poplin, Muslin, Voile, Lawn, Jersey, Drill &amp; Twill</p>
              </div>
            </div>
          </div>{/* featured-imagebox end*/}
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          {/*featured-imagebox*/}
          <div className="featured-imagebox featured-imagebox-services style1">
            {/* featured-thumbnail */}
            <div className="featured-thumbnail">
              <img className="img-fluid" src="images/services/services-02-768x512.jpg" alt="image" />
            </div>{/* featured-thumbnail end*/}
            <div className="featured-content">
              <div className="featured-title">
                <h3><a href="fabric-dyeing.html">Inspection of Home Textiles
                  </a></h3>
                <div className="ttm-details-link">
                  <a href="fabric-dyeing.html"><i className="themifyicon ti-arrow-top-right" /></a>
                </div>
              </div>
              <div className="featured-desc">
                <p>Home Textiles Quality Inspection &amp; Testing Services
                  Nask International provides quality inspection, quality testing services, quality assurance, and compliance support for all types of textile items and textile made-ups. We conduct thorough product testing and quality assurance inspections. Some of the key items we cover include:
                  ⊕ Textile Made-ups
                  ⊕ Cotton Curtains &amp; Drapes
                  ⊕ Bed Sheets
                  ⊕ Pillows &amp; Covers
                  ⊕ Cushions &amp; Covers
                  ⊕ Furnishing Fabrics &amp; Upholstery
                  ⊕ Duvets &amp; Duvet Covers
                  ⊕ Cotton Protecting Sheets
                  ⊕ Bed Covers
                  ⊕ Fitted Bedsheets
                  ⊕ Bed Linen
                  ⊕ Table Cloths</p>
              </div>
            </div>
          </div>{/* featured-imagebox end*/}
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          {/*featured-imagebox*/}
          <div className="featured-imagebox featured-imagebox-services style1">
            {/* featured-thumbnail */}
            <div className="featured-thumbnail">
              <img className="img-fluid" src="images/services/services-03-768x512.jpg" alt="image" />
            </div>{/* featured-thumbnail end*/}
            <div className="featured-content">
              <div className="featured-title">
                <h3><a href="engineering.html">Inspection of Promotional Textile</a></h3>
                <div className="ttm-details-link">
                  <a href="engineering.html"><i className="themifyicon ti-arrow-top-right" /></a>
                </div>
              </div>
              <div className="featured-desc">
                <p>Nask International provides quality inspection and product testing services to ensure compliance with the standards required by our clients during the inspection of promotional textile items. Our Promotional Textile Inspection covers, but is not limited to, the following products:
                  ⊕ Promotional Event Wear
                  ⊕ Promotional Work Aprons
                  ⊕ Promotional Cushions
                  ⊕ Promotional Pillows
                  ⊕ Promotional Napkins
                  ⊕ Promotional Caps &amp; Sun Shades
                  ⊕ Promotional Cotton Tote Bags
                </p>
              </div>
            </div>
          </div>{/* featured-imagebox end*/}
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          {/*featured-imagebox*/}
          <div className="featured-imagebox featured-imagebox-services style1">
            {/* featured-thumbnail */}
            <div className="featured-thumbnail">
              <img className="img-fluid" src="images/services/services-04-768x512.jpg" alt="image" />
            </div>{/* featured-thumbnail end*/}
            <div className="featured-content">
              <div className="featured-title">
                <h3><a href="manufacture.html">Inspection of Garments &amp; Apparel</a></h3>
                <div className="ttm-details-link">
                  <a href="manufacture.html"><i className="themifyicon ti-arrow-top-right" /></a>
                </div>
              </div>
              <div className="featured-desc">
                <p>Nask International provides comprehensive quality inspection services for garments and apparel, covering various quality standards, processing protocols, laboratory tests, and compliance factors. Our third-party inspection services ensure quality implementation at every stage of garment manufacturing and apparel stitching.
                  Our inspections include:
                  ⊕ Knitted Garments &amp; Apparel
                  ⊕ Woven Garments &amp; Apparel
                  ⊕ Men’s Garments
                  ⊕ Women’s Garments
                  ⊕ Children’s Garments
                  ⊕ Fashion Garments
                  ⊕ Fashion Wear
                  ⊕ T-Shirts</p>
              </div>
            </div>
          </div>{/* featured-imagebox end*/}
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          {/*featured-imagebox*/}
          <div className="featured-imagebox featured-imagebox-services style1">
            {/* featured-thumbnail */}
            <div className="featured-thumbnail">
              <img className="img-fluid" src="images/services/services-05-768x512.jpg" alt="image" />
            </div>{/* featured-thumbnail end*/}
            <div className="featured-content">
              <div className="featured-title">
                <h3><a href="manufacture.html">Product Inspection (others)</a></h3>
                <div className="ttm-details-link">
                  <a href="manufacture.html"><i className="themifyicon ti-arrow-top-right" /></a>
                </div>
              </div>
              <div className="featured-desc">
                <p>Nask International offers product inspection services across a wide range of categories, from textiles to consumer goods and from technical to electronic products. Our inspection services ensure quality assurance and conformance in the following categories:
                  ⊕ Textiles &amp; Textile Made-Ups
                  ⊕ Home Textiles
                  ⊕ Kitchen Textiles
                  ⊕ Apparel &amp; Garments
                  ⊕ Food &amp; Confectionery
                  ⊕ Furniture &amp; Home Products
                  ⊕ Electrical Products
                  ⊕ IT &amp; Electronics
                  ⊕ Safety &amp; Security Products
                  ⊕ Hotel Products
                  ⊕ Fashion Products
                  ⊕ Sports Products</p>
              </div>
            </div>
          </div>{/* featured-imagebox end*/}
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          {/*featured-imagebox*/}
          <div className="featured-imagebox featured-imagebox-services style1">
            {/* featured-thumbnail */}
            <div className="featured-thumbnail">
              <img className="img-fluid" src="images/services/services-06-768x512.jpg" alt="image" />
            </div>{/* featured-thumbnail end*/}
            <div className="featured-content">
              <div className="featured-title">
                <h3><a href="manufacture.html">Inspection of Denim Products</a></h3>
                <div className="ttm-details-link">
                  <a href="manufacture.html"><i className="themifyicon ti-arrow-top-right" /></a>
                </div>
              </div>
              <div className="featured-desc">
                <p>Nask International offers Denim Fabric Inspection, Denim Wear Quality Inspection, and Denim Apparel Quality Inspection services, along with related testing and quality control, for our international clients, buyers, and partners.
                  Our qualified and experienced textile quality inspectors specialize in all types of product testing to ensure compliance with international standards.
                  Our Denim Product Inspection &amp; Quality Testing covers, but is not limited to, the following items:
                  ⊕ Denim Jeans
                  ⊕ Denim Shorts
                  ⊕ Denim Skirts
                  ⊕ Denim Tops
                  ⊕ Denim Fabric Rolls
                  ⊕ Promotional Denim Wear
                  ⊕ Other Denim Products</p>
              </div>
            </div>
          </div>{/* featured-imagebox end*/}
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          {/*featured-imagebox*/}
          <div className="featured-imagebox featured-imagebox-services style1">
            {/* featured-thumbnail */}
            <div className="featured-thumbnail">
              <img className="img-fluid" src="images/services/services-06-768x512.jpg" alt="image" />
            </div>{/* featured-thumbnail end*/}
            <div className="featured-content">
              <div className="featured-title">
                <h3><a href="manufacture.html">Process Inspection</a></h3>
                <div className="ttm-details-link">
                  <a href="manufacture.html"><i className="themifyicon ti-arrow-top-right" /></a>
                </div>
              </div>
              <div className="featured-desc">
                <p>Quality Assurance cannot be guaranteed without rigorous inspection and quality checks at every stage of production. From product design and raw material procurement to manufacturing, stitching, packing, and shipment, every step must be monitored to ensure the highest standards.
                  Nask International's process inspections help implement quality standards at the right time, ensuring superior finished products while reducing costs and enhancing their monetary value.
                  Our Process Inspection Services include, but are not limited to:
                  ⊕ Procurement Process Inspection
                  ⊕ Designing &amp; Planning Process Inspection
                  ⊕ Manufacturing Process Inspection (All Products)
                  ⊕ Stitching Process Inspection
                </p>
              </div>
            </div>
          </div>{/* featured-imagebox end*/}
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          {/*featured-imagebox*/}
          <div className="featured-imagebox featured-imagebox-services style1">
            {/* featured-thumbnail */}
            <div className="featured-thumbnail">
              <img className="img-fluid" src="images/services/services-06-768x512.jpg" alt="image" />
            </div>{/* featured-thumbnail end*/}
            <div className="featured-content">
              <div className="featured-title">
                <h3><a href="manufacture.html">Inspection of Towels</a></h3>
                <div className="ttm-details-link">
                  <a href="manufacture.html"><i className="themifyicon ti-arrow-top-right" /></a>
                </div>
              </div>
              <div className="featured-desc">
                <p>Nask International provides quality inspection services for Terry Towels, Jacquard Towels, and other towel products, ensuring the right quality, timely delivery, and compliance with all standards. Our inspections cover fabric and yarn quality, weaving, dyeing, processing, stitching, embroidery, labeling, and packaging to meet international requirements.
                  Our Towel Inspection Services include, but are not limited to:
                  ⊕ Terry Towel Fabric
                  ⊕ Jacquard Towel Fabric Rolls
                  ⊕ Bath Towels
                  ⊕ Hotel Towels
                  ⊕ Kids’ Towel Hoods
                  ⊕ Beach Towels
                  ⊕ Bath Gowns
                  ⊕ Bamboo Towels
                  ⊕ Promotional Towels
                  ⊕ Hand Towels
                  ⊕ Towel Sheets
                  ⊕ Embroidered Towels
                  ⊕ Printed Towels</p>
              </div>
            </div>
          </div>{/* featured-imagebox end*/}
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          {/*featured-imagebox*/}
          <div className="featured-imagebox featured-imagebox-services style1">
            {/* featured-thumbnail */}
            <div className="featured-thumbnail">
              <img className="img-fluid" src="images/services/services-06-768x512.jpg" alt="image" />
            </div>{/* featured-thumbnail end*/}
            <div className="featured-content">
              <div className="featured-title">
                <h3><a href="manufacture.html">Laboratory &amp; Technical Testing</a></h3>
                <div className="ttm-details-link">
                  <a href="manufacture.html"><i className="themifyicon ti-arrow-top-right" /></a>
                </div>
              </div>
              <div className="featured-desc">
                <p>Laboratory Testing of finished product, process, chemicals, raw material and micro ingredients of the products essentially become very important when it comes to quality assurance and strict control. Global business leaders take advantage of these testing services as a support to their business. NASK International, through its network of quality partner labs provides best testing services for textiles, apparels, fabrics, garments, consumer and food products. Some of the testing services are:
                  ⊕ ASTM F963-16 -for Toys  ⊕Phthalates Testing  ⊕Food Testing  ⊕Product Quality Assurance Tests ⊕RoHS ⊕SASO ⊕CPSIA ⊕REACH</p>
              </div>
            </div>
          </div>{/* featured-imagebox end*/}
        </div>
      </div>
      {/* row end */}
    </div>
  </section>
  
  )
}

export default ListingInspection